import { render } from "./GlobalCurrencyBar.vue?vue&type=template&id=1fcfdbd5&scoped=true"
import script from "./GlobalCurrencyBar.vue?vue&type=script&lang=js"
export * from "./GlobalCurrencyBar.vue?vue&type=script&lang=js"

import "./GlobalCurrencyBar.vue?vue&type=style&index=0&id=1fcfdbd5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcfdbd5"]])

export default __exports__